module.exports = __webpack_public_path__ + "img/hahalogo.ab1f1244.png";